exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.scrollable-body[data-v-bad8097a] {\n  max-height: 400px;\n  overflow: auto;\n}\n@media screen and (max-width: 600px) {\n.modal-large[data-v-bad8097a] {\n    height: 100vh !important;\n    background-color: red !important;\n}\n.mover-earnings-title[data-v-bad8097a] {\n    text-align: center;\n    margin-top: 4rem;\n    margin-bottom: 4rem;\n    font-size: 1.2rem;\n    font-weight: 400 !important;\n    color: black;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-bad8097a","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/MoverWagesModal.vue
// module id = 9lZF
// module chunks = 0